import { logException } from "@wss/error-tracking";
import { toError } from "@wss/error-tracking/utils";

export type OrderGuideData = {
  categories: string[];
  subordinateAccounts: {
    userId: string;
    categories: string[];
    company: string;
    name: string;
  }[];
};

const isItemAlreadyInOrderGuide = async (
  itemNumber: string,
): Promise<boolean> => {
  const getOrderGuideDataEndpoint = `/myaccount/spa/orderguide/matchingorderguideitems/`;

  try {
    const response = fetch(getOrderGuideDataEndpoint, {
      body: JSON.stringify({ itemNumbers: [itemNumber] }),
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });

    const result = await (
      await response
    ).json<{
      itemNumbersInOrderGuide: string[];
    }>();

    return result.itemNumbersInOrderGuide
      .map((itemNbr) => itemNbr.toLowerCase)
      .includes(itemNumber.toLowerCase);
  } catch (e) {
    const error = new Error("Error in isItemAlreadyInOrderGuide", {
      cause: toError(e),
    });

    await logException(error);

    return false;
  }
};

export default isItemAlreadyInOrderGuide;
